export default __webpack_public_path__ + "static/media/bear1.ea690f87.png";